var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shop-address"},[_c('Header',{attrs:{"backType":"blank","back":true}}),_c('div',{staticClass:"container",attrs:{"id":"container"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }